import { combineReducers } from 'redux';
import list from 'employees/reducers/employees_list_reducers';
import form from 'employees/reducers/employees_form_reducers';

export const employeesReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/reducers/index.js